module.exports = __webpack_public_path__ + "img/p6-p2-diaoxiang.c10075d4.png";